import React, { memo, useMemo } from 'react';

import PropTypes from 'prop-types';

import { ActionStepStatus, ActionStepType } from 'constants/aiChat';

import ActionStepGroup from '../../../../ActionStepGroup';

import { mapActionStepPropsToGroupStep } from './ActionStepGroupContent.utils';

const ActionStepGroupContent = ({ contentProps }) => {
  const {
    groupId,
    label,
    status,
    subStepType = null,
    progressText = null,
    nestedSteps = [],
  } = contentProps;

  const steps = useMemo(
    () => nestedSteps.map(nested => mapActionStepPropsToGroupStep(nested.id, nested.contentProps)),
    [nestedSteps],
  );

  return (
    <ActionStepGroup
      actionStepType={subStepType}
      key={groupId}
      label={label}
      progressText={progressText}
      status={status}
      steps={steps}
    />
  );
};

ActionStepGroupContent.propTypes = {
  contentProps: PropTypes.shape({
    groupId: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired,
    status: PropTypes.oneOf(Object.values(ActionStepStatus)).isRequired,
    subStepType: PropTypes.oneOf(Object.values(ActionStepType)),
    progressText: PropTypes.string,
    nestedSteps: PropTypes.array,
  }).isRequired,
};

export default memo(ActionStepGroupContent);
